import { render, staticRenderFns } from "./yxqnSwitch.vue?vue&type=template&id=21ba6dd4&scoped=true"
import script from "./yxqnSwitch.vue?vue&type=script&lang=js"
export * from "./yxqnSwitch.vue?vue&type=script&lang=js"
import style0 from "./yxqnSwitch.vue?vue&type=style&index=0&id=21ba6dd4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ba6dd4",
  null
  
)

export default component.exports